export const PARTNER360_NAMESPACE = 'partner360'
